__turbopack_context__.v({
  "rotate": "SpinnerIcon-module-scss-module__24jtbq__rotate",
  "spinner-icon": "SpinnerIcon-module-scss-module__24jtbq__spinner-icon",
});
